import { createContext, useContext, useEffect, useMemo, useRef, useState } from "react";
import { DebouncedInput } from "../../../components_new/debounce-input/debounce-input";
import { models } from "powerbi-client";

export const DashboardFilter = ({ DashboardContext }) => {
  const [filterObject, setFilterObject] = useState({ name: "" });
  const { setFilteredReportings, reportings } = useContext(DashboardContext);

  const changeFilterObject = (name, val) => {
    let newFilterObject = { ...filterObject, [name]: val };
    setFilterObject(newFilterObject);
    filterData(newFilterObject);
  };

  const filterData = (fObject) => {
    let newReportings;
    if (!fObject || !fObject?.name || fObject.name === "") {
      newReportings = reportings;
    } else {
      newReportings = reportings.filter((r) => r?.name?.toLowerCase().includes(fObject.name.toLowerCase()));
    }
    setFilteredReportings(newReportings);
  };

  return (
    <div>
      <DebouncedInput
        name="filter-name"
        placeholder={`🔍Filter Dashboards`}
        value={filterObject.name}
        onChange={(val) => changeFilterObject("name", val)}
      />
    </div>
  );
};


 const generateValues = (val) => {
    let values = val.split(",");
    for (let i = 0; i < values.length; i++) {
      if(values[i].length < 8)
      {
      while (values[i].length < 8) {
        values[i] = "0" + values[i];
      }
      values[i] = parseInt(values[i])
      }
    }
    return values;
  };
  
  export const createFilter = (filters) => {
    const result = [];
    for (let i = 0; i < filters.length; i++) {
      const element = filters[i];
      const filter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: element["table_name"],
          column: element["column_name"],
        },
        operator: "In",
        values: generateValues(element["value"]),
        // values: ["monkeys"],
        filterType: models.FilterType.Basic,
      };
      result.push(filter);
    }
    
    return result;
  };

 export const applyInFilter = async (embedConfig, reportingInstance) => {
    const result = createFilter(embedConfig["data_filters"]);
    try {
      await reportingInstance.current.updateFilters(models.FiltersOperations.Add, result);
    } catch (error) {
      console.error("Error applying filter:", error);
    }
    return new Promise((resolve) => resolve(true));
  };